export default "__VITE_ASSET__C7dDsMzU__"